
export default {
  name: 'schedule-filter-mobile-date',
  props: {
    value: {
      type: [Object, String, Number],
      default: null,
    },
    available: {
      type: Array,
      default: () => ([]),
    },
    prices: {
      type: Object,
      default: () => ({
        dateStart: new Date(),
        prices: [],
      }),
    },
  },
  data: () => ({
    isShowList: false,
    selected: null,
    mountKey: 0,
  }),
  computed: {
    dateString() {
      if (!this.selected) return '';
      return `${this.selected.from.date}.${this.selected.from.month.value}.${this.selected.from.year} - ${this.selected.to.date}.${this.selected.to.month.value}.${this.selected.to.year}`;
    }, 
  },
  watch: {
    value: {
      handler(newVal) {
        this.selected = newVal;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    showList() {
      this.isShowList = true;
    },
    hideList() {
      this.isShowList = false;
    },
    selectItem(item) {
      this.$set(this, 'selected', item);
    },
    apply() {
      this.$emit('input', this.selected);
      this.mountKey += 1;
      this.hideList();
    },
  },
};
